import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { LightThemeColors } from '../../Themes';

import styles from './Line.Styles';
import LineTypes from './LineTypes';

function Line({ theme, index, noOfSteps, activeIndex, type, isEditMode }) {
  const isVisible = type === LineTypes.LEFT ? index !== 0 : index !== noOfSteps - 1;
  const isRed = type === LineTypes.LEFT ? index - 1 < activeIndex : index < activeIndex;
  return (
    <View
      style={[
        styles.lineStyle(theme),
        isVisible ? styles.visibleLineStyle : styles.invisibleLineStyle,
        isRed || isEditMode ? styles.redLineStyle(theme) : {},
      ]}
      testID={FoundationTestKeys.horizontalStepperLineView}
    />
  );
}

Line.defaultProps = {
  theme: LightThemeColors,
  isEditMode: false,
};

Line.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  index: PropTypes.number,
  noOfSteps: PropTypes.number,
  activeIndex: PropTypes.number,
  type: PropTypes.oneOf(Object.values(LineTypes)),
  isEditMode: PropTypes.bool,
};

export default Line;
